import { escapedCountry } from 'utils/transform';
import errors from './errors';

export const orderSummary = {
  subtotal: 'Subtotal',
  fees: 'Fees',
  calculatedNext: 'Calculated at next step',
  discountApplied: 'Discount applied',
  vat: 'VAT',
  tax: 'Tax',
  total: 'Total',
  shipping: 'Shipping',
  hide: 'Hide order summary',
  show: 'Show order summary',
};

export const donationForm = {
  title: 'Select a Donation Amount',
  customAmount: 'Custom amount',
  message: 'Add a message to your donation',
  paysFees:
    'Pay the transaction fees on behalf of your charity and ensure they receive your full donation',
  paysFeesTooltip:
    'All donations have a small processing fee, but you can cover that cost for your charity ensuring they get the full benefit of your donation. Please note that fees vary based on payment method.',
  anonymous: 'Remain anonymous',
  errors: {
    amount: {
      min: 'Minumum donation amount is 3.00',
      required: 'Amount is required',
    },
  },
  submit: 'Donate Now',
};
export const shopperDetails = {
  title: 'Shopper Information',
  subtitle: 'For secure payments, please enter your details below',
  email: 'Email address',
  phone: 'Phone',
  name: 'Name',

  errors: {
    email: {
      required: 'Email address is required',
      invalid: 'Invalid email address',
    },
    phone: {
      required: 'Phone number is required',
      invalid: 'Invalid phone number',
    },
    name: {
      required: 'Name is required',
      fullName: 'Please enter your full name',
    },
  },
  submit: 'Continue',
  change: 'Change',
};

export const verification = {
  title: 'Enter your 6-digit code',
  subtitle: 'Please enter the code to continue securely with your purchase',
  information:
    'We have sent your verification code via sms. If you have not received the code, please click ',
  requestCode: 'Resend Code',

  errors: {
    code: {
      required: 'Verification code is required',
    },
  },
  submit: 'Verify',
};

export const shippingDetails = {
  title: 'Shipping Details',
  name: 'Name',
  address: 'Address',
  postcode: 'Postcode',
  country: escapedCountry,
  city: 'City',

  errors: {
    city: errors.city,
    country: errors.country,
    postcode: {
      required: 'Postcode is required',
    },
    address: {
      required: 'Address is required',
    },
    recipient_name: errors.name,
  },
  submit: 'Continue to Payment',
  change: 'Change',
};

export const billingAddress = {
  title: 'Billing Address',
  title_shipping: 'Shipping Address',
  sameAddress: 'Same as Shipping Address',
  useDifferent: 'Use a different Billing Address',

  address: 'Address',
  postcode: 'Postcode',
  country: escapedCountry,
  city: 'City',
  name: 'Name',
  company_name: 'Company Name',
  state: 'State',
  errors: {
    name: errors.name,
    city: errors.city,
    country: errors.country,
    postcode: {
      required: 'Postcode is required',
    },
    address: {
      required: 'Address is required',
    },
  },
  submit: 'Buy Now',
};
export const paymentMethod = {
  title: 'Payment Method',

  addNewCard: 'Add new debit or credit card',
  tryAgain: 'Please try again',
  defaultError: 'Unfortunately your payment failed',

  submit: 'Buy Now',
};
export default {
  subheader: 'Pay Securely with',
  empty: 'Your cart is empty',
  emptySubtitle: "Looks like you haven't added anything yet.",
  browse: 'Browse fundraisers',

  orderSummary,
  shopperDetails,
};
